import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "./CardUI";
import StatCardSkeleton from "../../../../core/components/skeleton/StatCardSkeleton";

const StatCard = ({
  icon: Icon,
  title,
  value,
  delta,
  trend,
  onClick,
  loading,
}) => {
  const trendColor = trend === "up" ? "text-green-500" : "text-red-500";
  const trendArrow = trend === "up" ? "▲" : "▼";

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 300 }}
      onClick={onClick}
      className="cursor-pointer"
    >
      {loading ? (
        <StatCardSkeleton />
      ) : (
        <Card className="shadow-md hover:shadow-lg transition-shadow">
          <CardContent className="flex items-center justify-between p-4">
            <div>
              <p className="text-sm text-gray-500">{title}</p>
              <h3 className="text-2xl font-bold">{value}</h3>
              <p className={`text-xs font-semibold mt-1 ${trendColor}`}>
                {trendArrow} {delta}
                <span className="text-gray-500 font-normal ml-1">
                  {trend === "up" ? "increase" : "decrease"} this month
                </span>
              </p>
            </div>

            <Icon className="w-8 h-8 text-gray-400" />
          </CardContent>
        </Card>
      )}
    </motion.div>
  );
};

export default StatCard;
